<header class="header">
  <div class="container-core">
    <div class="header-title">
      <div class="header__icon"></div>
    </div>
  </div>
</header>
